// Vendor Libs
import {Component} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Styles
import 'flexlayout-react/style/light.css';
import './flex-dashboard.scss';

export default class Hotkeys extends Component {
    componentWillMount() {
        window.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress);
    }

    handleKeyPress = (event) => {
        const {hotkeys = {}, keyCodes = {}} = this.props;

        if (event && !event.altKey && !event.ctrlKey && !event.metaKey) {
            const keyHandler = get(hotkeys, event.key) || get(keyCodes, event.keyCode);

            if (keyHandler) {
                event.preventDefault && event.preventDefault();

                keyHandler();
            }
        }
    };

    render() {
        return null;
    }
}

Hotkeys.propTypes = {
    hotkeys: PropTypes.object,
    keyCodes: PropTypes.object,
};
